import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _12771d6b = () => interopDefault(import('../../../pages/activity.vue' /* webpackChunkName: "pages/activity" */))
const _33ed553e = () => interopDefault(import('../../../pages/chatbot-preview.vue' /* webpackChunkName: "pages/chatbot-preview" */))
const _2706d064 = () => interopDefault(import('../../../pages/commands.vue' /* webpackChunkName: "pages/commands" */))
const _005b11bc = () => interopDefault(import('../../../pages/commissions.vue' /* webpackChunkName: "pages/commissions" */))
const _4ef530c0 = () => interopDefault(import('../../../pages/consultation-scripts.vue' /* webpackChunkName: "pages/consultation-scripts" */))
const _0f4c5bd6 = () => interopDefault(import('../../../pages/crm-opportunities.vue' /* webpackChunkName: "pages/crm-opportunities" */))
const _4c21e53e = () => interopDefault(import('../../../pages/diff.vue' /* webpackChunkName: "pages/diff" */))
const _7f5cce2a = () => interopDefault(import('../../../pages/email-preview.vue' /* webpackChunkName: "pages/email-preview" */))
const _1d8c37b4 = () => interopDefault(import('../../../pages/employer-plans.vue' /* webpackChunkName: "pages/employer-plans" */))
const _8869574c = () => interopDefault(import('../../../pages/employer-report.vue' /* webpackChunkName: "pages/employer-report" */))
const _1b22a8ec = () => interopDefault(import('../../../pages/employers.vue' /* webpackChunkName: "pages/employers" */))
const _7f9099b1 = () => interopDefault(import('../../../pages/enroll-thank-you.vue' /* webpackChunkName: "pages/enroll-thank-you" */))
const _6916634e = () => interopDefault(import('../../../pages/forgot-password.vue' /* webpackChunkName: "pages/forgot-password" */))
const _5c0007f0 = () => interopDefault(import('../../../pages/intake.vue' /* webpackChunkName: "pages/intake" */))
const _2608da01 = () => interopDefault(import('../../../pages/keep-plans/index.vue' /* webpackChunkName: "pages/keep-plans/index" */))
const _50c1fdb2 = () => interopDefault(import('../../../pages/link-login.vue' /* webpackChunkName: "pages/link-login" */))
const _9a71d686 = () => interopDefault(import('../../../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _be4ee55a = () => interopDefault(import('../../../pages/magic-redirect-error.vue' /* webpackChunkName: "pages/magic-redirect-error" */))
const _19ba1b32 = () => interopDefault(import('../../../pages/mistake.vue' /* webpackChunkName: "pages/mistake" */))
const _3104b228 = () => interopDefault(import('../../../pages/print-window.vue' /* webpackChunkName: "pages/print-window" */))
const _4b976eff = () => interopDefault(import('../../../pages/register.vue' /* webpackChunkName: "pages/register" */))
const _b1d90594 = () => interopDefault(import('../../../pages/schedule/index.vue' /* webpackChunkName: "pages/schedule/index" */))
const _32e4c6f8 = () => interopDefault(import('../../../pages/search.vue' /* webpackChunkName: "pages/search" */))
const _5d898702 = () => interopDefault(import('../../../pages/settings.vue' /* webpackChunkName: "pages/settings" */))
const _1d940a7d = () => interopDefault(import('../../../pages/summary/index.vue' /* webpackChunkName: "pages/summary/index" */))
const _534dc796 = () => interopDefault(import('../../../pages/summary-scripts.vue' /* webpackChunkName: "pages/summary-scripts" */))
const _0d08098e = () => interopDefault(import('../../../pages/survey/index.vue' /* webpackChunkName: "pages/survey/index" */))
const _12937090 = () => interopDefault(import('../../../pages/thank-you.vue' /* webpackChunkName: "pages/thank-you" */))
const _61d1f7fd = () => interopDefault(import('../../../pages/email/client-email-consultation.vue' /* webpackChunkName: "pages/email/client-email-consultation" */))
const _2bf1f26e = () => interopDefault(import('../../../pages/email/client-survey-consultation.vue' /* webpackChunkName: "pages/email/client-survey-consultation" */))
const _3b8515c9 = () => interopDefault(import('../../../pages/email/email-consultation.vue' /* webpackChunkName: "pages/email/email-consultation" */))
const _bf955c8e = () => interopDefault(import('../../../pages/email/email-verify.vue' /* webpackChunkName: "pages/email/email-verify" */))
const _4574f867 = () => interopDefault(import('../../../pages/email/employer-report.vue' /* webpackChunkName: "pages/email/employer-report" */))
const _1c4ff8e0 = () => interopDefault(import('../../../pages/email/light-summary.vue' /* webpackChunkName: "pages/email/light-summary" */))
const _3edb4585 = () => interopDefault(import('../../../pages/email/link-login.vue' /* webpackChunkName: "pages/email/link-login" */))
const _558d5be8 = () => interopDefault(import('../../../pages/email/otp.vue' /* webpackChunkName: "pages/email/otp" */))
const _4105a3ac = () => interopDefault(import('../../../pages/email/pdf-summary.vue' /* webpackChunkName: "pages/email/pdf-summary" */))
const _143ff3f4 = () => interopDefault(import('../../../pages/email/pre-consult-survey.vue' /* webpackChunkName: "pages/email/pre-consult-survey" */))
const _31c37bf0 = () => interopDefault(import('../../../pages/email/reset-password.vue' /* webpackChunkName: "pages/email/reset-password" */))
const _54dceef2 = () => interopDefault(import('../../../pages/email/summary.vue' /* webpackChunkName: "pages/email/summary" */))
const _a359b7a0 = () => interopDefault(import('../../../pages/email/support.vue' /* webpackChunkName: "pages/email/support" */))
const _2fae3b6b = () => interopDefault(import('../../../pages/email/task-done.vue' /* webpackChunkName: "pages/email/task-done" */))
const _6e9cccfe = () => interopDefault(import('../../../pages/email/test.vue' /* webpackChunkName: "pages/email/test" */))
const _198dc7dd = () => interopDefault(import('../../../pages/email/zen-summary.vue' /* webpackChunkName: "pages/email/zen-summary" */))
const _2898b41a = () => interopDefault(import('../../../pages/survey/aep.vue' /* webpackChunkName: "pages/survey/aep" */))
const _214acdf6 = () => interopDefault(import('../../../pages/survey/completion.vue' /* webpackChunkName: "pages/survey/completion" */))
const _78b65d52 = () => interopDefault(import('../../../pages/survey/demographics.vue' /* webpackChunkName: "pages/survey/demographics" */))
const _3a17aeba = () => interopDefault(import('../../../pages/survey/drugs.vue' /* webpackChunkName: "pages/survey/drugs" */))
const _617cce5c = () => interopDefault(import('../../../pages/survey/income.vue' /* webpackChunkName: "pages/survey/income" */))
const _d2242b84 = () => interopDefault(import('../../../pages/survey/landing.vue' /* webpackChunkName: "pages/survey/landing" */))
const _c8716672 = () => interopDefault(import('../../../pages/survey/new.vue' /* webpackChunkName: "pages/survey/new" */))
const _5bf8073a = () => interopDefault(import('../../../pages/survey/pharmacies.vue' /* webpackChunkName: "pages/survey/pharmacies" */))
const _ea33f2d8 = () => interopDefault(import('../../../pages/survey/plans/index.vue' /* webpackChunkName: "pages/survey/plans/index" */))
const _e5abb8ee = () => interopDefault(import('../../../pages/survey/providers.vue' /* webpackChunkName: "pages/survey/providers" */))
const _97be33a8 = () => interopDefault(import('../../../pages/survey/soa.vue' /* webpackChunkName: "pages/survey/soa" */))
const _2a3eda2c = () => interopDefault(import('../../../pages/survey/step-by-step.vue' /* webpackChunkName: "pages/survey/step-by-step" */))
const _3230f84d = () => interopDefault(import('../../../pages/survey/summary.vue' /* webpackChunkName: "pages/survey/summary" */))
const _7911ae09 = () => interopDefault(import('../../../pages/survey/welcome.vue' /* webpackChunkName: "pages/survey/welcome" */))
const _d300372e = () => interopDefault(import('../../../pages/survey/plans/_pids.vue' /* webpackChunkName: "pages/survey/plans/_pids" */))
const _771d4fd1 = () => interopDefault(import('../../../pages/group/_slug/index.vue' /* webpackChunkName: "pages/group/_slug/index" */))
const _c28dbf78 = () => interopDefault(import('../../../pages/reset-password/_token.vue' /* webpackChunkName: "pages/reset-password/_token" */))
const _b5464824 = () => interopDefault(import('../../../pages/schedule/_slug.vue' /* webpackChunkName: "pages/schedule/_slug" */))
const _0fc39540 = () => interopDefault(import('../../../pages/start-enrollment/_pid.vue' /* webpackChunkName: "pages/start-enrollment/_pid" */))
const _32a6efb6 = () => interopDefault(import('../../../pages/summary/_id.vue' /* webpackChunkName: "pages/summary/_id" */))
const _78bea9fd = () => interopDefault(import('../../../pages/survey/_uid/index.vue' /* webpackChunkName: "pages/survey/_uid/index" */))
const _54cda38e = () => interopDefault(import('../../../pages/group/_slug/articles.vue' /* webpackChunkName: "pages/group/_slug/articles" */))
const _908df95c = () => interopDefault(import('../../../pages/group/_slug/drugs.vue' /* webpackChunkName: "pages/group/_slug/drugs" */))
const _2df78424 = () => interopDefault(import('../../../pages/group/_slug/faqs.vue' /* webpackChunkName: "pages/group/_slug/faqs" */))
const _7085ea28 = () => interopDefault(import('../../../pages/group/_slug/frame.vue' /* webpackChunkName: "pages/group/_slug/frame" */))
const _06427c7e = () => interopDefault(import('../../../pages/group/_slug/reports.vue' /* webpackChunkName: "pages/group/_slug/reports" */))
const _397d7d2e = () => interopDefault(import('../../../pages/group/_slug/videos.vue' /* webpackChunkName: "pages/group/_slug/videos" */))
const _ef7b98cc = () => interopDefault(import('../../../pages/group/_slug/webinars.vue' /* webpackChunkName: "pages/group/_slug/webinars" */))
const _f7d71c98 = () => interopDefault(import('../../../pages/survey/_uid/activity.vue' /* webpackChunkName: "pages/survey/_uid/activity" */))
const _f2c99492 = () => interopDefault(import('../../../pages/survey/_uid/aep.vue' /* webpackChunkName: "pages/survey/_uid/aep" */))
const _39eaf67e = () => interopDefault(import('../../../pages/survey/_uid/completion.vue' /* webpackChunkName: "pages/survey/_uid/completion" */))
const _e9ee83da = () => interopDefault(import('../../../pages/survey/_uid/demographics.vue' /* webpackChunkName: "pages/survey/_uid/demographics" */))
const _8d4b4504 = () => interopDefault(import('../../../pages/survey/_uid/drugs.vue' /* webpackChunkName: "pages/survey/_uid/drugs" */))
const _1869c052 = () => interopDefault(import('../../../pages/survey/_uid/editor.vue' /* webpackChunkName: "pages/survey/_uid/editor" */))
const _1bd43d56 = () => interopDefault(import('../../../pages/survey/_uid/enrollment-period.vue' /* webpackChunkName: "pages/survey/_uid/enrollment-period" */))
const _328c2d29 = () => interopDefault(import('../../../pages/survey/_uid/health-lifestyle.vue' /* webpackChunkName: "pages/survey/_uid/health-lifestyle" */))
const _dd0bf284 = () => interopDefault(import('../../../pages/survey/_uid/income-surcharges.vue' /* webpackChunkName: "pages/survey/_uid/income-surcharges" */))
const _503ff802 = () => interopDefault(import('../../../pages/survey/_uid/landing.vue' /* webpackChunkName: "pages/survey/_uid/landing" */))
const _4fa7f2f6 = () => interopDefault(import('../../../pages/survey/_uid/pharmacies.vue' /* webpackChunkName: "pages/survey/_uid/pharmacies" */))
const _0d339258 = () => interopDefault(import('../../../pages/survey/_uid/plans/index.vue' /* webpackChunkName: "pages/survey/_uid/plans/index" */))
const _3a2fd04d = () => interopDefault(import('../../../pages/survey/_uid/providers.vue' /* webpackChunkName: "pages/survey/_uid/providers" */))
const _e3a390d2 = () => interopDefault(import('../../../pages/survey/_uid/quick-aep.vue' /* webpackChunkName: "pages/survey/_uid/quick-aep" */))
const _4f0875f0 = () => interopDefault(import('../../../pages/survey/_uid/soa.vue' /* webpackChunkName: "pages/survey/_uid/soa" */))
const _9b7700b4 = () => interopDefault(import('../../../pages/survey/_uid/step-by-step.vue' /* webpackChunkName: "pages/survey/_uid/step-by-step" */))
const _28f9f3de = () => interopDefault(import('../../../pages/survey/_uid/summary.vue' /* webpackChunkName: "pages/survey/_uid/summary" */))
const _3263bbcd = () => interopDefault(import('../../../pages/survey/_uid/welcome.vue' /* webpackChunkName: "pages/survey/_uid/welcome" */))
const _18cd702d = () => interopDefault(import('../../../pages/survey/_uid/plans/_pids.vue' /* webpackChunkName: "pages/survey/_uid/plans/_pids" */))
const _2dc11cb4 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/activity",
    component: _12771d6b,
    name: "activity"
  }, {
    path: "/chatbot-preview",
    component: _33ed553e,
    name: "chatbot-preview"
  }, {
    path: "/commands",
    component: _2706d064,
    name: "commands"
  }, {
    path: "/commissions",
    component: _005b11bc,
    name: "commissions"
  }, {
    path: "/consultation-scripts",
    component: _4ef530c0,
    name: "consultation-scripts"
  }, {
    path: "/crm-opportunities",
    component: _0f4c5bd6,
    name: "crm-opportunities"
  }, {
    path: "/diff",
    component: _4c21e53e,
    name: "diff"
  }, {
    path: "/email-preview",
    component: _7f5cce2a,
    name: "email-preview"
  }, {
    path: "/employer-plans",
    component: _1d8c37b4,
    name: "employer-plans"
  }, {
    path: "/employer-report",
    component: _8869574c,
    name: "employer-report"
  }, {
    path: "/employers",
    component: _1b22a8ec,
    name: "employers"
  }, {
    path: "/enroll-thank-you",
    component: _7f9099b1,
    name: "enroll-thank-you"
  }, {
    path: "/forgot-password",
    component: _6916634e,
    name: "forgot-password"
  }, {
    path: "/intake",
    component: _5c0007f0,
    name: "intake"
  }, {
    path: "/keep-plans",
    component: _2608da01,
    name: "keep-plans"
  }, {
    path: "/link-login",
    component: _50c1fdb2,
    name: "link-login"
  }, {
    path: "/login",
    component: _9a71d686,
    name: "login"
  }, {
    path: "/magic-redirect-error",
    component: _be4ee55a,
    name: "magic-redirect-error"
  }, {
    path: "/mistake",
    component: _19ba1b32,
    name: "mistake"
  }, {
    path: "/print-window",
    component: _3104b228,
    name: "print-window"
  }, {
    path: "/register",
    component: _4b976eff,
    name: "register"
  }, {
    path: "/schedule",
    component: _b1d90594,
    name: "schedule"
  }, {
    path: "/search",
    component: _32e4c6f8,
    name: "search"
  }, {
    path: "/settings",
    component: _5d898702,
    name: "settings"
  }, {
    path: "/summary",
    component: _1d940a7d,
    name: "summary"
  }, {
    path: "/summary-scripts",
    component: _534dc796,
    name: "summary-scripts"
  }, {
    path: "/survey",
    component: _0d08098e,
    name: "survey"
  }, {
    path: "/thank-you",
    component: _12937090,
    name: "thank-you"
  }, {
    path: "/email/client-email-consultation",
    component: _61d1f7fd,
    name: "email-client-email-consultation"
  }, {
    path: "/email/client-survey-consultation",
    component: _2bf1f26e,
    name: "email-client-survey-consultation"
  }, {
    path: "/email/email-consultation",
    component: _3b8515c9,
    name: "email-email-consultation"
  }, {
    path: "/email/email-verify",
    component: _bf955c8e,
    name: "email-email-verify"
  }, {
    path: "/email/employer-report",
    component: _4574f867,
    name: "email-employer-report"
  }, {
    path: "/email/light-summary",
    component: _1c4ff8e0,
    name: "email-light-summary"
  }, {
    path: "/email/link-login",
    component: _3edb4585,
    name: "email-link-login"
  }, {
    path: "/email/otp",
    component: _558d5be8,
    name: "email-otp"
  }, {
    path: "/email/pdf-summary",
    component: _4105a3ac,
    name: "email-pdf-summary"
  }, {
    path: "/email/pre-consult-survey",
    component: _143ff3f4,
    name: "email-pre-consult-survey"
  }, {
    path: "/email/reset-password",
    component: _31c37bf0,
    name: "email-reset-password"
  }, {
    path: "/email/summary",
    component: _54dceef2,
    name: "email-summary"
  }, {
    path: "/email/support",
    component: _a359b7a0,
    name: "email-support"
  }, {
    path: "/email/task-done",
    component: _2fae3b6b,
    name: "email-task-done"
  }, {
    path: "/email/test",
    component: _6e9cccfe,
    name: "email-test"
  }, {
    path: "/email/zen-summary",
    component: _198dc7dd,
    name: "email-zen-summary"
  }, {
    path: "/survey/aep",
    component: _2898b41a,
    name: "survey-aep"
  }, {
    path: "/survey/completion",
    component: _214acdf6,
    name: "survey-completion"
  }, {
    path: "/survey/demographics",
    component: _78b65d52,
    name: "survey-demographics"
  }, {
    path: "/survey/drugs",
    component: _3a17aeba,
    name: "survey-drugs"
  }, {
    path: "/survey/income",
    component: _617cce5c,
    name: "survey-income"
  }, {
    path: "/survey/landing",
    component: _d2242b84,
    name: "survey-landing"
  }, {
    path: "/survey/new",
    component: _c8716672,
    name: "survey-new"
  }, {
    path: "/survey/pharmacies",
    component: _5bf8073a,
    name: "survey-pharmacies"
  }, {
    path: "/survey/plans",
    component: _ea33f2d8,
    name: "survey-plans"
  }, {
    path: "/survey/providers",
    component: _e5abb8ee,
    name: "survey-providers"
  }, {
    path: "/survey/soa",
    component: _97be33a8,
    name: "survey-soa"
  }, {
    path: "/survey/step-by-step",
    component: _2a3eda2c,
    name: "survey-step-by-step"
  }, {
    path: "/survey/summary",
    component: _3230f84d,
    name: "survey-summary"
  }, {
    path: "/survey/welcome",
    component: _7911ae09,
    name: "survey-welcome"
  }, {
    path: "/survey/plans/:pids",
    component: _d300372e,
    name: "survey-plans-pids"
  }, {
    path: "/group/:slug",
    component: _771d4fd1,
    name: "group-slug"
  }, {
    path: "/reset-password/:token?",
    component: _c28dbf78,
    name: "reset-password-token"
  }, {
    path: "/schedule/:slug",
    component: _b5464824,
    name: "schedule-slug"
  }, {
    path: "/start-enrollment/:pid?",
    component: _0fc39540,
    name: "start-enrollment-pid"
  }, {
    path: "/summary/:id",
    component: _32a6efb6,
    name: "summary-id"
  }, {
    path: "/survey/:uid",
    component: _78bea9fd,
    name: "survey-uid"
  }, {
    path: "/group/:slug?/articles",
    component: _54cda38e,
    name: "group-slug-articles"
  }, {
    path: "/group/:slug?/drugs",
    component: _908df95c,
    name: "group-slug-drugs"
  }, {
    path: "/group/:slug?/faqs",
    component: _2df78424,
    name: "group-slug-faqs"
  }, {
    path: "/group/:slug?/frame",
    component: _7085ea28,
    name: "group-slug-frame"
  }, {
    path: "/group/:slug?/reports",
    component: _06427c7e,
    name: "group-slug-reports"
  }, {
    path: "/group/:slug?/videos",
    component: _397d7d2e,
    name: "group-slug-videos"
  }, {
    path: "/group/:slug?/webinars",
    component: _ef7b98cc,
    name: "group-slug-webinars"
  }, {
    path: "/survey/:uid/activity",
    component: _f7d71c98,
    name: "survey-uid-activity"
  }, {
    path: "/survey/:uid/aep",
    component: _f2c99492,
    name: "survey-uid-aep"
  }, {
    path: "/survey/:uid/completion",
    component: _39eaf67e,
    name: "survey-uid-completion"
  }, {
    path: "/survey/:uid/demographics",
    component: _e9ee83da,
    name: "survey-uid-demographics"
  }, {
    path: "/survey/:uid/drugs",
    component: _8d4b4504,
    name: "survey-uid-drugs"
  }, {
    path: "/survey/:uid/editor",
    component: _1869c052,
    name: "survey-uid-editor"
  }, {
    path: "/survey/:uid/enrollment-period",
    component: _1bd43d56,
    name: "survey-uid-enrollment-period"
  }, {
    path: "/survey/:uid/health-lifestyle",
    component: _328c2d29,
    name: "survey-uid-health-lifestyle"
  }, {
    path: "/survey/:uid/income-surcharges",
    component: _dd0bf284,
    name: "survey-uid-income-surcharges"
  }, {
    path: "/survey/:uid/landing",
    component: _503ff802,
    name: "survey-uid-landing"
  }, {
    path: "/survey/:uid/pharmacies",
    component: _4fa7f2f6,
    name: "survey-uid-pharmacies"
  }, {
    path: "/survey/:uid/plans",
    component: _0d339258,
    name: "survey-uid-plans"
  }, {
    path: "/survey/:uid/providers",
    component: _3a2fd04d,
    name: "survey-uid-providers"
  }, {
    path: "/survey/:uid/quick-aep",
    component: _e3a390d2,
    name: "survey-uid-quick-aep"
  }, {
    path: "/survey/:uid/soa",
    component: _4f0875f0,
    name: "survey-uid-soa"
  }, {
    path: "/survey/:uid/step-by-step",
    component: _9b7700b4,
    name: "survey-uid-step-by-step"
  }, {
    path: "/survey/:uid/summary",
    component: _28f9f3de,
    name: "survey-uid-summary"
  }, {
    path: "/survey/:uid/welcome",
    component: _3263bbcd,
    name: "survey-uid-welcome"
  }, {
    path: "/survey/:uid/plans/:pids",
    component: _18cd702d,
    name: "survey-uid-plans-pids"
  }, {
    path: "/",
    component: _2dc11cb4,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
